import { Injectable } from '@angular/core';
import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class CustomValidatorsService {

  constructor() { }

  /**
   * Validador personalizado para no permitir que un control contenga únicamente espacios en blanco.
   */
  static noWhitespaceValidator(control: AbstractControl): ValidationErrors | null {
    const isWhitespace = (control.value || '').trim().length === 0;
    return isWhitespace ? { 'whitespace': true } : null;
  }

  samePasswords( pass1: string, pass2: string ) {

    return ( formGroup: FormGroup ) => {
      const pass1Control = formGroup.controls[pass1];
      const pass2Control = formGroup.controls[pass2];
      if ( pass1Control.value === pass2Control.value ) {
        pass2Control.setErrors(null);
      } else {
        pass2Control.setErrors({ noEqual: true });
      }

    }

  }

  sumOfValues(insp: string, retr: string, rech: string) {
    return(formGroup: FormGroup) => {
      const inspControl = formGroup.controls[insp];
      const retrControl = formGroup.controls[retr];
      const rechControl = formGroup.controls[rech];
      if((Number(retrControl.value) + Number(rechControl.value)) <= Number(inspControl.value)) {
        inspControl.setErrors(null);
      } else {
        inspControl.setErrors({ incorrectValues: true });
      }
    }
  }
}
